import { createReducer, combineReducers } from '@reduxjs/toolkit';

import { Nullable, RequestState } from 'modules/types/common';
import { ConsumerPreferences } from './types';
import * as actions from './actions';

export interface ConsumerPreferencesState {
  consumerUiData: ConsumerUiDataState;
}

export interface ConsumerUiDataState {
  isFetching: boolean;
  data: ConsumerPreferences[] | [];
  error: Nullable<Error>;
  requestState: RequestState;
  lastUpdated: string | undefined;
}

export const consumerUiDataInitialState = (): ConsumerUiDataState => ({
  isFetching: false,
  data: [],
  error: null,
  requestState: RequestState.INITIALIZED,
  lastUpdated: undefined
});

const consumerUiDataReducer = createReducer(consumerUiDataInitialState(), {
  [actions.GET_CONSUMER_SHARED_UI_DATA]: state => {
    state.isFetching = true;
    state.error = null;
    state.requestState = RequestState.REQUESTING;
  },
  [actions.GET_CONSUMER_SHARED_UI_DATA_SUCCESS]: (state, action) => {
    state.isFetching = false;
    state.data = action.payload.data;
    state.requestState = RequestState.SUCCESS;
  },
  [actions.GET_CONSUMER_SHARED_UI_DATA_FAIL]: (state, action) => {
    state.isFetching = false;
    state.error = action.error;
    state.requestState = RequestState.ERROR;
  },
  [actions.UPDATE_CONSUMER_SHARED_UI_DATA]: state => {
    state.isFetching = true;
    state.error = null;
  },
  [actions.UPDATE_CONSUMER_SHARED_UI_DATA_SUCCESS]: state => {
    state.isFetching = false;
  },
  [actions.UPDATE_CONSUMER_SHARED_UI_DATA_FAIL]: (state, action) => {
    state.isFetching = false;
    state.error = action.error;
  },
  [actions.UPDATE_CONSUMER_AVATAR]: state => {
    state.isFetching = true;
    state.error = null;
  },
  [actions.UPDATE_CONSUMER_AVATAR_SUCCESS]: (state, action) => {
    state.isFetching = false;
    state.data[0].uiData.sharedUiData = action.meta.previousAction.payload.request.data;
  },
  [actions.UPDATE_CONSUMER_AVATAR_FAIL]: (state, action) => {
    state.isFetching = false;
    state.error = action.error;
  },
  [actions.SET_LANGUAGE]: (state, action) => {
    state.data = [
      {
        uiData: {
          sharedUiData: {
            preferredLanguage: action.payload
          }
        }
      }
    ];
  }
});

export default combineReducers({
  consumerUiData: consumerUiDataReducer
});
